export enum EAdCreditStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export enum EDURATION_TYPE {
  DAY = "DAY",
  MONTH = "MONTH",
}

export enum EDiscountType {
  PERCENT = "PERCENT",
  PRICE = "PRICE",
}

export enum EUserAdCreditAction {
  ADD = "add",
  DEDUCT = "deduct",
}

export enum EUserAdCreditReasonType {
  CREDIT_PURCHASE = "credit-purchase",
  AD_CAMPAIGN_PAYMENT = "ad-campaign",
  REFUND = "refund",
  OTHER = "other",
  UPDATE = "update",
  DEBT_PAYMENT = "debt-payment",
}

export enum ECreditDeductionCategory {
  GOOGLE_ADS = "google-ads",
  LEAD = "lead",
  FACEBOOK = "facebook",
  MISCELLANEOUS = "miscellaneous",
}

export enum ECreditAddCategory {
  TOP_UP = "topup",
  REFUND = "refund",
  BONUS = "bonus",
}

export interface IAdCredit {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  name: string;
  status: EAdCreditStatus;
  amount: number;
  price: string;
  duration: number;
  durationType: EDURATION_TYPE;
  discount: string;
  discountType: EDiscountType;
  isHidden: boolean;
  position: number;
  isPopular: boolean;
}

export interface ICreateAdCreditPackageDTO {
  name: string;
  amount: number;
  price: number;
  assignUserId: string;
  expiredAt?: string;
}

export interface IUpdateAdCreditDTO {
  userId: string;
  amount: number;
  reason?: string;
  duration?: number;
  durationType?: EDURATION_TYPE;
  category?: ECreditDeductionCategory | ECreditAddCategory;
}

export interface IUserAdCreditInfoGeneral {
  balance: number;
  amountExpiringSoon: number;
  adCreditData: IUserAdCredit[];
  summary: {
    totalTopUp: number;
    totalSpending: number;
    netBalance: number;
    expiredCredit: number;
  };
  categoryBreakdown: {
    facebook: ICategoryBreakdown;
    "google-ads": ICategoryBreakdown;
    miscellaneous: ICategoryBreakdown;
    lead: ICategoryBreakdown;
  };
}

export interface IUerAdCreditHistory {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  userId: string;
  reason: string;
  reasonType: string;
  action: EUserAdCreditAction;
  adCreditId: string;
  userAdCreditId: string;
  userAdCreditData: UserAdCreditData;
  transactionID: string;
  amount: number;
  category?: ECreditDeductionCategory | ECreditAddCategory;
  contactSaleSubmissionId?: string;
}
export interface IUserAdCreditCollapseHistory {
  transactionID: string;
  amount: number;
  action: EUserAdCreditAction;
  reasonType?: EUserAdCreditReasonType;
  reason?: string;
  histories: IUerAdCreditHistory[];
  canRevert: boolean;
}

export interface UserAdCreditData {
  id: string;
  amount: number;
  status: string;
  userId: string;
  createdAt: string;
  deletedAt: string | null;
  expiredAt: string | null;
  isExpired: boolean;
  updatedAt: string;
}

export interface IUserAdCredit {
  id: string;
  name: string;
  amount: number;
  price: number;
  duration: number;
  durationType: EDURATION_TYPE;
  assignUserId: string;
  status: EAdCreditStatus;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  expiredAt: string | null;
}

export interface AdCreditBalance {
  total: number;
  expiring: number;
}

export interface AdCreditTransaction {
  id: string;
  date: Date;
  creditIn: number | null;
  creditOut: number | null;
  reason: string;
  expiryDate: Date | null;
}

export interface AdCreditPackageDetails {
  name: string;
  expiryDate: Date;
  creditPrice: number;
}

export interface AdCreditOrder {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  userId: string;
  adCreditData: IUserAdCredit;
  amount: number;
  price: string;
}

export interface IBodyRevertTransaction {
  userId: string;
}

export interface ICategoryBreakdown {
  totalIn: number;
  totalOut: number;
  total: number;
}
